export default __webpack_public_path__ + "static/media/homescreen.af047758.png";